<template>
  <div>
    <v-container>
      <v-row v-if="activeProjects.length > 0" align="center">
        <v-autocomplete
          :items="activeProjects"
          item-text="name"
          item-value="id"
          v-model="selectedProject"
          placeholder="Select a project"
        >
        </v-autocomplete>
        <v-btn
          fab
          dark
          x-small
          color="orange darken-3"
          v-if="selectedProject !== null"
          @click="routeToProject(selectedProject)"
          class="ml-4"
          ><v-icon dark>mdi-arrow-right</v-icon></v-btn
        >
      </v-row>
      <v-row v-else>
        <div class="text-center">
          <p>
            Sorry, there are no projects associated with your account. <br />
            Please
            <a
              href="https://www.wrike.com/workspace.htm?acc=2361792#path=request-forms&accountid=2361792&formid=287775"
              target="_blank"
              >contact TechOps</a
            >
            for assistance.
          </p>
          <v-btn color="secondary" small class="mt-4" @click="logout"
            >Logout</v-btn
          >
        </div>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      selectedProject: null,
    };
  },
  methods: {
    routeToProject(id) {
      /*//change based on admin status
      this.$router.push({
        name: "Project",
        params: { id: id, status: "unassigned" },
      });*/

      let user = this.userAdminId;
      if (this.userAdminStatus) {
        this.$router.push({ path: `/project/a/${user}/${id}/review` });
      } else {
        this.$router.push({ path: `/project/a/${user}/${id}/myNew` });
      }
    },
    logout() {
      this.$store.dispatch("user/logout");
    },
  },
  computed: {
    ...mapGetters({
      activeProjects: "projects/activeProjects",
      userAdminStatus: "user/userAdminStatus",
      userAdminId: "user/userAdminId",
    }),
  },
};
</script>

<style lang="scss" scoped>
h1 {
  text-align: center;
}
</style>
